/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FleetAuthenticatePeriodListUpdate
 */
export interface FleetAuthenticatePeriodListUpdate {
    /**
     * 
     * @type {boolean}
     * @memberof FleetAuthenticatePeriodListUpdate
     */
    eventId?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FleetAuthenticatePeriodListUpdate
     */
    userEmployeeId?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FleetAuthenticatePeriodListUpdate
     */
    vehicleSerialNumber?: boolean | null;
}

/**
 * Check if a given object implements the FleetAuthenticatePeriodListUpdate interface.
 */
export function instanceOfFleetAuthenticatePeriodListUpdate(value: object): value is FleetAuthenticatePeriodListUpdate {
    return true;
}

export function FleetAuthenticatePeriodListUpdateFromJSON(json: any): FleetAuthenticatePeriodListUpdate {
    return FleetAuthenticatePeriodListUpdateFromJSONTyped(json, false);
}

export function FleetAuthenticatePeriodListUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): FleetAuthenticatePeriodListUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'eventId': json['eventId'] == null ? undefined : json['eventId'],
        'userEmployeeId': json['userEmployeeId'] == null ? undefined : json['userEmployeeId'],
        'vehicleSerialNumber': json['vehicleSerialNumber'] == null ? undefined : json['vehicleSerialNumber'],
    };
}

export function FleetAuthenticatePeriodListUpdateToJSON(json: any): FleetAuthenticatePeriodListUpdate {
    return FleetAuthenticatePeriodListUpdateToJSONTyped(json, false);
}

export function FleetAuthenticatePeriodListUpdateToJSONTyped(value?: FleetAuthenticatePeriodListUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'eventId': value['eventId'],
        'userEmployeeId': value['userEmployeeId'],
        'vehicleSerialNumber': value['vehicleSerialNumber'],
    };
}

